import React from 'react';
import { motion } from 'framer-motion';
import { Terminal, Mail, Github } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { Button } from '../ui/button';

const Footer = () => {
  const { personalInfo } = useAppContext();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-border/50 py-12 relative">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex items-center mb-4">
              <Terminal className="h-6 w-6 text-primary mr-2" />
              <span className="text-xl font-bold terminal-text">
                <span className="text-primary">{'>'}</span> Portfolio
                <span className="text-primary">_</span>
              </span>
            </div>
            <p className="text-foreground/70 mb-4">
              {personalInfo.bio.substring(0, 120)}...
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="md:text-center"
          >
            <h3 className="text-lg font-bold mb-4 terminal-text">
              <span className="text-primary">{'>'}</span> Quick Links
            </h3>
            <ul className="space-y-2">
              {['About', 'Education', 'Experience', 'Projects', 'Contact'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase()}`}
                    className="text-foreground/70 hover:text-primary transition-colors animated-underline"
                  >
                    <span className="text-primary">/</span>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="md:text-right"
          >
            <h3 className="text-lg font-bold mb-4 terminal-text">
              <span className="text-primary">{'>'}</span> Connect
            </h3>
            <div className="flex space-x-4 md:justify-end mb-6">
              <a
                href={personalInfo.socialLinks.github}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-secondary/50 rounded-full hover:bg-primary/20 transition-colors"
              >
                <Github className="h-5 w-5 text-primary" />
              </a>
              <a
                href={`mailto:${personalInfo.email}`}
                className="p-2 bg-secondary/50 rounded-full hover:bg-primary/20 transition-colors"
              >
                <Mail className="h-5 w-5 text-primary" />
              </a>
            </div>
            <p className="text-foreground/70">
              {personalInfo.email}
              <br />
              {personalInfo.location}
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="border-t border-border/50 mt-8 pt-8 text-center"
        >
          <p className="text-foreground/60 flex items-center justify-center">
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
